import { render } from "./DefaultSettingsView.vue?vue&type=template&id=1100465f"
import script from "./DefaultSettingsView.vue?vue&type=script&lang=js"
export * from "./DefaultSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__